// ToastProvider.js
import React from "react";
import { Toaster } from "react-hot-toast";

export const ToastProvider = ({ children }) => (
  <>
    {children}
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 6000,
        style: {
          fontSize: "1.05rem",
          lineHeight: "1.25",
        },
        success: {
          style: {
            background: "#51a351",
            color: "white",
            textAlign: "left",
          },
          className: "success-toast",
        },
        error: {
          style: {
            background: "#bd362f",
            color: "white",
            textAlign: "left",
          },
        },
      }}
    />
  </>
);